<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-calendar"></i>关于我们</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" >
            <mavon-editor v-model="content" ref="md" @imgAdd="$imgAdd" @change="change" style="min-height: 600px"/>
            <el-button class="editor-btn" type="primary" @click="editdata()">提交</el-button>
        </div>
    </div>
</template>

<script>
    import { post } from '../../../api/request';
    import { mavonEditor } from 'mavon-editor'
    import 'mavon-editor/dist/css/index.css'
    export default {
        name: 'markdown',
        data: function(){
            return {
                tableData:{
                    content:'',
                    label:'',
                    id:'',
                },
                companyid:'',
                content:'',
                html:'',
                configs: {
                }
            }
        },
        components: {
            mavonEditor
        },
        created() {
            this.companyid =  sessionStorage.getItem('companyid')
            this.getData()
        },
        activated() {
            this.companyid =  sessionStorage.getItem('companyid')
            this.getData()
        },
        methods: {
            getData(){
                let formdata = new FormData()
                formdata.append("company_id",this.companyid)
                post("admin/home/selabout",formdata).then(res=>{
                    this.tableData = res.data.data[0]
                    this.content = res.data.data[0].content
                })
            },
            editdata(){
                let formdata = new FormData()
                formdata.append("id",this.tableData.id) 
                formdata.append("label",this.tableData.label) 
                formdata.append("content",this.content)  
                  formdata.append("company_id",this.companyid)
                post("admin/home/updabout",formdata).then(res=>{
                    if(res.data.msg =="修改成功")
                    {
                        this.$message.success("修改成功")
                    }
                })
            },
            // 将图片上传到服务器，返回地址替换到md中
            $imgAdd(pos, $file){
                var formdata = new FormData();
                formdata.append('file', $file);
                // 这里没有服务器供大家尝试，可将下面上传接口替换为你自己的服务器接口
                post('admin/file/url',formdata).then((res) => {
                    this.$refs.md.$img2Url(pos, res.data);
                })
            },
            change(value, render){
                // render 为 markdown 解析后的结果
                this.tableData.label = render;
            },
            submit(){
                this.$message.success('提交成功！');
            }
        }
    }
</script>
<style scoped>
    .editor-btn{
        margin-top: 20px;
    }
</style>